// Verify Contact Step
import rules from "../../Data/Rules"
import store from "../../veux/store";
import functions from "../../Data/Functions"
import MD5 from "md5";
import { createToastInterface } from "vue-toastification";

const toast_options = {
    // You can set your default toast options here
    timeout: 2000,
    position: "bottom-center",
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
};

// Create Toast the interface
const toast = createToastInterface(toast_options);

// Verify Contact Step Schema
let Verify_Step = {
    stepno: 1,
    title: 'Verify',
    nextBtn: "NO",
    // backBtn: "NO",
    // submitBtn: "NO"
    valid: true,
    information: ``,
    Schema: {
        lookupmethod: {
            type: "radio",
            label: 'Please select an option: ',
            outlined: true,
            row: true,
            dense: true,
            hidden: true,
            col: 12,
            // rules: [rules.requiredMsg('Selection is Required')],
            class: 'mx-1 px-1',
            options: ["I know my Login Details", "I don't know, or have, any login details"],
        },
        login: {
            type: 'text',
            label: 'Username or Login',
            outlined: true,
            dense: true,
            hidden: true,
            rules: [],
            class: 'mx-1 px-1',
        },
        password: {
            type: 'password',
            label: 'Password',
            outlined: true,
            dense: true,
            appendIcon: "lock",
            hidden: true,
            rules: [],
            class: 'mx-1 px-1'
        },
        Contact_id: {
            type: 'number',
            label: 'Contact id',
            outlined: true,
            dense: true,
            hidden: true,
            rules: [],
            class: 'mx-1 px-1',
            OUG: { Contacts: { Field: "Contact_id" } }
        },
        firstname: {
            type: 'text',
            label: 'First Name',
            outlined: true,
            dense: true,
            hidden: false,
            rules: [rules.requiredMsg('Firstname is Required')],
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.firstname = functions.capitalizeFirstLetter(ev.data.firstname).trim();
            },
            // Startslot: `<h4>We need to check if you have previously registered on our Platform.</br></br>
            //     To do this we need to check your personal details against previous registrations.</br></br></h4>`,
        },
        surname: {
            type: 'text',
            label: 'Last Name',
            outlined: true,
            dense: true,
            hidden: false,
            rules: [rules.requiredMsg('Surname is Required')],
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.surname = functions.capitalizeFirstLetter(ev.data.surname).trim();
            }
        },
        gender: {
            type: "select",
            label: "Gender",
            outlined: true,
            dense: true,
            hidden: true,
            // rules: [rules.requiredMsg('Gender is Required')],
            class: 'mx-1 px-1',
            items: rules.Gender,
        },
        DOB: {
            type: 'text',
            ext: 'date',
            locale: 'en',
            label: `Date of Birth (${store.getters.getdateFormat})`,
            outlined: true,
            dense: true,
            hidden: false,
            mask: store.getters.getdateMask,
            rules: [rules.requiredMsg('Date of Birth is Required'),
            rules.minAge(`You must be over 6 years old to Join`, '2018-04-03'),
            ],
            class: 'mx-1 px-1',
            onInput: async (ev, portal) => {
                ev.data.entered_DOB = ev.data.DOB
            },
        },
        entered_DOB: {
            type: 'text',
            ext: 'date',
            locale: 'en',
            label: `Date of Birth (${store.getters.getdateFormat})`,
            outlined: true,
            dense: true,
            hidden: true,
            class: 'mx-1 px-1',
            onInput: async (ev, portal) => { },
        },
        codedelivery: {
            type: "select",
            label: 'Select method of Verification',
            outlined: true,
            dense: true,
            // hidden: true,
            rules: [rules.requiredMsg('Verification Delivery Method is Required')],
            class: 'mx-1 px-1',
            items: ["Email", "Mobile"],
        },
        email: {
            type: 'email',
            label: 'Email Address',
            outlined: true,
            dense: true,
            hidden: true,
            rules: [],
            class: 'mx-1 px-1'
        },
        mobile: {
            type: 'tel',
            label: 'Phone Number',
            outlined: true,
            dense: true,
            hidden: true,
            rules: [],
            mask: "####-###-###",
            class: 'mx-1 px-1'
        },
        verifycode: {
            type: 'text',
            label: 'Enter Code Received',
            outlined: true,
            dense: true,
            hidden: true,
            class: 'text-center autofocus',
            col: 12,
            rules: [],
            class: 'mx-1 px-1',
            Startslot: `<h4 style="text-align:center;color:lightgreen">We have found a profile for you on our Platform.</br></br></h4>`,
            Endslot: `<H4 style="text-align:center;color:lightgreen">We have sent you a verification code 
                to access your record - please enter it above!</H4><br>
                <H4 style="text-align:center;color:red">If you do not recieve the code, your Email or 
                Mobile may be different to what is on your profile<br><br>If so, click on the Need Help link below to get help!</H4>`,
            onInput: (ev, portal, home) => {
                let currentAccess = store.getters.currentAccess
                if (ev.data.verifycode.length === 6) {
                    if ((ev.data.verifycode) && (MD5(ev.data.verifycode) === currentAccess)) {
                        home.data.Model.Contact_id = store.getters.currentUser.Contact_id
                        // code correct proceed
                        return new Promise((resolve, reject) => {
                            let payload = {
                                Contact_id: store.getters.currentUser.Contact_id
                            }
                            store
                                .dispatch("getContactDetails", payload)
                                .then(() => {
                                    if (store.getters.userDetails.length > 0) {
                                        if (home.data.steps[(home.currentStep)].PreStep) {
                                            home.data.steps[(home.currentStep)].PreStep(home.data.steps[(home.currentStep)], home.data)
                                        }
                                        home.next()
                                        resolve()
                                    }
                                })
                        })
                    } else {
                        // code incorrect stop'
                        ev.data.verifycode = ''
                        toast.error(`Code entered was incorrect - please try again`, {
                            timeout: 3000,
                        });
                    }
                }
            }
        },
        verify: {
            type: 'btn',
            block: true,
            rounded: true,
            hidden: false,
            color: "orange",
            col: 12,
            label: 'Continue',
            iconRight: 'check',
            class: 'mx-0 px-10',
            onClick: (val, home) => {
                let { data, schema, obj } = val
                if (home.$refs.stepForm[home.currentStep - 1].validate()) {
                    return new Promise((resolve, reject) => {
                        let payload = {
                            Contact: {
                                firstname: data.firstname,
                                surname: data.surname,
                                date_of_birth: data.DOB,
                                method: data.codedelivery
                            },
                        }
                        functions.setBQExpiry('2000-01-01')
                        let sql = `select DATE(MAX(Expiry)) AS Expiry from _BC_Dump 
                                        WHERE DOB = '${data.DOB}' AND LEFT(Firstname,3) = '${data.firstname.substr(0, 3)}' 
                                        AND Surname = '${data.surname}'`
                        functions.getData(sql, false)
                            .then((result) => {
                                if (result[0].Expiry) {
                                    functions.setBQExpiry(functions.FormatDate(result[0].Expiry, 'YYYY-MM-DD'))
                                }
                            })
                        store
                            .dispatch("lookupuser", payload)
                            .then((result) => {
                                if (store.getters.currentUser) {
                                    // Record found so bring up verification field
                                    schema.verify.disabled = true
                                    schema.verify.hidden = true
                                    schema.firstname.hidden = true
                                    schema.surname.hidden = true
                                    schema.DOB.hidden = true
                                    schema.codedelivery.hidden = true
                                    schema.verifycode.rules = [rules.codeCheck(store.getters.currentAccess)]
                                    schema.verifycode.hidden = false
                                    resolve()
                                } else {
                                    // Not Found so reject
                                    home.next()
                                    resolve()
                                }
                            })
                    })
                }
            }
        },
    },
}

export default {

    LoadSchema: async (Step) => {
        Verify_Step.stepno = Step
        return Verify_Step
    },

}